<template>
  <div class="corset-base">
    <!-- Draw view -->
    <draw-view
      v-if="showDrawView"
      v-model="corset[blobProp]"
      :background-image="drawViewBgImg"
      @on-save="saveDrawView"
      @go-back="showDrawView = false"
    />

    <v-card
      v-if="!showDrawView"
      flat
      tile
    >
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <!-- Step One -->
          <v-window-item>
            <StepOne
              :form="corset"
              @corset-sketch="drawView('blob_corset', 'schema_corset_1b.svg')"
              @cutout-sketch="drawView('blob_decoupe', 'schema_corset_1c.svg')"
            />
          </v-window-item>

          <!-- Step Two -->
          <v-window-item>
            <StepTwo
              :form="corset"
              :dropdowns="dropdowns"
            />
          </v-window-item>
        </v-container>
      </v-window>
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handleProducts from "@/mixins/handleProducts.js";

import DrawView from "../../components/DrawView";
import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";

export default {
  name: "CorsetBase",
  components: {
    DrawView,
    StepOne,
    StepTwo
  },
  mixins: [handleProducts],
  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      // How many steps for this product
      steps: 2,
      onboarding: 0,
      dialog: false,

      showDrawView: false,

      // Dropdowns
      dropdowns: {},

      corset: JSON.parse(JSON.stringify(this.$store.state.corset.corset)),

      blobProp: null,
      drawViewBgImg: null
    };
  },
  beforeDestroy() {
    this.$store.dispatch("corset/resetProduct");
  },
  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.corset, this.projectUuid, "CORSET");
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    drawView(blobProp = null, bgImage = null) {
      if (blobProp) {
        this.blobProp = blobProp;
      }

      if (bgImage) {
        const image = require(`../../../assets/img/${bgImage}`);
        this.drawViewBgImg = image;
      }

      this.showDrawView = true;
    },

    saveDrawView() {
      this.blobProp = null;
      this.showDrawView = false;
    }
  }
};
</script>
